import { render, staticRenderFns } from "./TitleChanger.vue?vue&type=template&id=d7522dea&"
import script from "./TitleChanger.vue?vue&type=script&lang=js&"
export * from "./TitleChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports